import * as React from 'react'
import { connect } from 'react-redux'
// import type { Brief } from 'types/brief' // You'll need to create this type
import type { State } from 'types/redux'
import { TabStepsNav } from 'components/ui'
import Stack from 'components/ui/stack'
import { useSelector } from 'hooks/use-redux'
import {
  getBrief,
  getValidBriefSteps,
} from '@disco/state-management/reducers/entities/briefs'
import {
  BriefNavSteps,
  NAVIGATION_STEPS,
  BRIEF_CONTENT_TAB,
  EMAIL_DETAILS_TAB,
  CHOOSE_RECIPIENTS_TAB,
  CONFIRM_AND_SEND_TAB,
  getStepLink,
} from 'features/briefs/utils/nav'

interface Props {
  activeStep: BriefNavSteps
  briefId: number
}

export const BriefNav = ({ activeStep, briefId }: Props) => {
  const brief = useSelector(state => getBrief(state, { briefId }))
  const validBriefSteps = useSelector(state =>
    getValidBriefSteps(state, { briefId }),
  )

  const _validateStep = (step: BriefNavSteps) => {
    const { validContent, validEmailDetails, validRecipients, sendAllowed } =
      validBriefSteps

    switch (step) {
      case BRIEF_CONTENT_TAB:
        return validContent
      case EMAIL_DETAILS_TAB:
        return validEmailDetails
      case CHOOSE_RECIPIENTS_TAB:
        return validRecipients
      case CONFIRM_AND_SEND_TAB:
        return false // Never mark last step as complete
      default:
        return true
    }
  }

  if (!brief || brief.loading) return null

  return (
    <Stack>
      <TabStepsNav
        items={NAVIGATION_STEPS.map((step, index) => {
          const active = activeStep === step
          const completed = _validateStep(step) && !active
          return {
            label: `0${index + 1} ${step}`,
            link: getStepLink(briefId.toString(), step),
            active,
            completed,
          }
        })}
      />
    </Stack>
  )
}
